import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaThumbsUp, FaUpload, FaFileInvoice, FaFileAlt, FaPen, FaFileInvoiceDollar, FaPlus, FaSearch, FaHandHoldingUsd, FaEdit } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import NavItem from '../../../../components/NavItem';
import IconButton from '../../../../components/IconButton';
import Alert from '../../../../components/Alert';
import api from '../../../../services/api';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Data from '../../../../components/Data';
import UploadButton from '../../../../components/UploadButton';
import FormButton from '../../../../components/FormButton';
import { dataMysql, moeda } from '../../../../util/util';
import { Link } from 'react-router-dom';
import ReactSelect from '../../../../components/ReactSelect';

export default function PainelParcelaReceber() {
    let { state } = useLocation();
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({
        tipo: 2,
        empresa: empresa,
        idTitulo: state?.idTitulo ?? null,
    }); //1 - pagar | 2 - receber
    const [dados, setDados] = useState({ pagamento: new Date() });
    const [parcelas, setParcelas] = useState([]);
    const [tableSelect, setTableSelect] = useState([]);
    const [tableActions, setTableActions] = useState([]);
    const params = new URLSearchParams(window.location.search);
    const grupoTitulo = params.get('grupoTitulo');

    const buscar = () => {
        setFiltro({...filtro,...{buscando: true}});
        api({
            method: 'get',
            action: '/financeiroParcela',
            token: token,
            params: {
                ...filtro,
                ...{ grupoTitulo: grupoTitulo },
            }
        })
            .then(response => {
                setParcelas(response.data.data);
                setFiltro({...filtro,...{buscando: false}});
            }).catch(err => {
                //console.log(err)
            })
    };

    useEffect(() => { //onload
        buscar();
    }, 
    // eslint-disable-next-line
    []);

    useEffect(() => { //onload
        buscar();
    }, 
    // eslint-disable-next-line
    [filtro.tipo, filtro.evento]);

    useEffect(() => { //onload
        var ids = tableSelect.selectedRows ? tableSelect.selectedRows.map((row) => {
            return row.id;
        }).join(",") : "";
        if (tableSelect.selectedCount > 0) {
            setTableActions([
                <IconButton
                    small={true}
                    to={{
                        pathname: "/financeiro/alterarContaFornecedor",
                        state: {
                            idParcelas: tableSelect.selectedRows.map((parcela) => { return parcela.id; }),
                        }
                    }} icon={<FaEdit size={20} />}
                    color="primary">Alterar Conta e Fornecedor</IconButton>,
                ((tableSelect.selectedRows.length === 1) && //apenas 1 selecionado
                    (tableSelect.selectedRows[0].situacao === "1")) //apenas se ainda estiver em aberto 
                    ?
                    <IconButton
                        small={true}
                        icon={<FaThumbsUp size={20} />}
                        onClick={() => {
                            Alert({
                                icon: "question",
                                confirmButton: <><FaThumbsUp size={20} /> Receber</>,
                                denyButton: "Sair",
                                title: "Receber Parcela",
                                html:
                                    <Data
                                        readOnly={true}
                                        label="Data Pagamento"
                                        value={dados.pagamento}
                                        onChange={(date) => {
                                            dados.pagamento = date;
                                            setDados({ ...dados });
                                        }}
                                    />,
                                callBack: (result) => {
                                    //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                                    if (result.isConfirmed) {
                                        api({
                                            method: 'put',
                                            action: '/financeiroParcela/' + tableSelect.selectedRows[0].id,
                                            token: token,
                                            data: {
                                                situacao: "2",
                                                pagamento: dataMysql(dados.pagamento)
                                            }
                                        })
                                            .then(function (response) {
                                                buscar();
                                                //alert("Evento cancelado com sucesso!");
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }
                                }
                            });
                        }
                        }
                        color="primary"> Receber</IconButton > : null,
                ((tableSelect.selectedRows.length === 1) && //apenas 1 selecionado
                    ((tableSelect.selectedRows[0].situacao === "1") || (['diretor', 'gerentefinanceiro'].includes(perfil)))) ? //apenas gerente financeiro 
                    <IconButton
                        small={true}
                        icon={<ImCancelCircle size={20} />}
                        onClick={() => {
                            Alert({
                                icon: "error",
                                confirmButton: "Sair",
                                denyButton: <><FaThumbsUp size={20} /> Excluir</>,
                                title: "Excluir Parcela",
                                callBack: (result) => {
                                    //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                                    if (result.isDenied) {
                                        api({
                                            method: 'delete',
                                            action: '/financeiroParcela/' + tableSelect.selectedRows[0].id,
                                            token: token
                                        })
                                            .then(function (response) {
                                                buscar();
                                                //alert("Evento cancelado com sucesso!");
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }
                                }
                            });
                        }
                        }
                        color="primary"> Excluir</IconButton > : null,
                ((tableSelect.selectedRows.length === 1) && //apenas 1 selecionado
                    (tableSelect.selectedRows[0].situacao === "1")) //apenas se ainda estiver em aberto 
                    ?
                    <IconButton
                        small={true}
                        title="Registrar abatimento de juros"
                        to={{
                            pathname: "/cadastroParcelaPagar",
                            state: {
                                parcelaabater: tableSelect.selectedRows[0].id,
                                acao: "insert"
                            }
                        }}
                        icon={<FaHandHoldingUsd size={20} />}
                        color={"primary"} >Antecipação de Crédito</IconButton> : null,
                tableSelect.selectedRows.length === 1 ? //apenas 1 selecionado
                    <UploadButton
                        small={true}
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"financeiroParcelaArquivo/" + tableSelect.selectedRows[0].id}
                        title="Boleto"
                        callBack={() => { buscar(); }}
                        dados={{
                            tipoArquivo: "boleto",
                            modulo: "financeiro",
                            pasta: "boleto"
                        }}
                    >Boleto</UploadButton> : null,
                tableSelect.selectedRows.length === 1 ? //apenas 1 selecionado
                    <UploadButton
                        small={true}
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"financeiroParcelaArquivo/" + tableSelect.selectedRows[0].id}
                        title="Comprovante de pagamento"
                        callBack={() => { buscar(); }}
                        dados={{
                            tipoArquivo: "comprovantepagamento",
                            modulo: "financeiro",
                            pasta: "comprovantepagamento"
                        }}
                    >Comprovante</UploadButton> : null
            ]);
        } else {
            setTableActions([]);
        }
    }, 
    // eslint-disable-next-line
    [tableSelect]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroParcelaReceber" icon={<FaPlus size={20} />} color="primary">Nova Receita</NavItem>
                    <NavItem to={{
                        pathname: "/financeiroParcelaRelatorio",
                        state: {
                            tipo: 2 //2 - receber
                        }
                    }}
                        icon={<FaFileAlt size={20} />}
                        color="outline-dark">Relatório de contas a receber</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Receber</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { filtro.idTitulo = null; buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Data
                                                        label="Data Vencimento"
                                                        value={filtro.dataVencimento1}
                                                        onChange={date => setFiltro({ ...filtro, ...{ "dataVencimento1": date } })}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Data
                                                        label="até a Data Vencimento"
                                                        value={filtro.dataVencimento2}
                                                        onChange={date => setFiltro({ ...filtro, ...{ "dataVencimento2": date } })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            value={{ value: filtro.participante, label: filtro.nomeParticipante }}
                                                            onChange={e => setFiltro({ ...filtro, ...{ "participante": e.value, "nomeParticipante": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Plano de Contas</label>
                                                        <ReactSelect
                                                            value={{ value: filtro.conta, label: filtro.nomeConta }}
                                                            onChange={e => setFiltro({ ...filtro, ...{ "conta": e.value, "nomeConta": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/financeiroPlanoConta',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipo: "1",
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.caminho + ' - ' + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="descricao" placeholder="Descrição"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "descricao": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Descrição</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            progressComponent={<div>Buscando...</div>}
                                            noContextMenu="true"
                                            actions={tableActions}
                                            selectableRows="true"
                                            selectableRowsHighlight="true"
                                            onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
                                                setTableSelect({ allSelected, selectedCount, selectedRows });
                                            }}
                                            noDataComponent="Nenhum registro"
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: (row) => {
                                                        if (row.situacao === "1") { //1 - aberto
                                                            return <IconButton
                                                                small={true}
                                                                to={"/cadastroParcelaReceber/" + row.titulo.id}
                                                                icon={<FaPen size={20} />}
                                                                color="primary">Alterar</IconButton>;
                                                        } else {
                                                            return null;
                                                        }

                                                    },
                                                    width: "110px",
                                                },
                                                {
                                                    name: '',
                                                    selector: 'arquivoboleto',
                                                    cell: row => row.arquivoboleto?.id ? <FormButton
                                                        method="get"
                                                        title="Boleto"
                                                        action={process.env.REACT_APP_API_URL + "/financeiroParcelaArquivo/" + row.id}
                                                        icon={<FaFileInvoice size={20} />}
                                                        color="primary"
                                                        data={{
                                                            token: localStorage.getItem('token'),
                                                            tipoArquivo: "boleto"
                                                        }}
                                                    /> : null,
                                                    width: "60px",
                                                },
                                                {
                                                    name: '',
                                                    selector: 'arquivocomprovantepagamento',
                                                    cell: row => row.arquivocomprovantepagamento?.id ? <FormButton
                                                        method="get"
                                                        title="Comprovante Pagamento"
                                                        action={process.env.REACT_APP_API_URL + "/financeiroParcelaArquivo/" + row.id}
                                                        icon={<FaFileInvoiceDollar size={20} />}
                                                        color="primary"
                                                        data={{
                                                            token: localStorage.getItem('token'),
                                                            tipoArquivo: "comprovantepagamento"
                                                        }}
                                                    /> : null,
                                                    width: "60px",
                                                },
                                                {
                                                    name: 'Situação',
                                                    selector: row => row.situacao ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    cell: (row) => {
                                                        return row.situacao === "1" ? "Aberto" : "Pago";
                                                    },
                                                },
                                                {
                                                    name: 'Número',
                                                    selector: row => row.titulo?.numero ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    right: true,
                                                },
                                                {
                                                    name: 'Conta',
                                                    width: "150px",
                                                    cell: (row) => {
                                                        return row.conta ? row.conta.caminho + ' - ' + row.conta.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Caixa',
                                                    width: "130px",
                                                    cell: (row) => {
                                                        return row.caixa ? row.caixa.codigo + '-' + row.caixa.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Referência',
                                                    cell: (row) => {
                                                        var textoReferencia = row.titulo.venda.map((venda) => venda.codigo ? venda.codigo : "Cliente").join(",");
                                                        var referencia = <div>
                                                            <Link
                                                                title="Faturas relacionadas"
                                                                to={{
                                                                    pathname: "/venda",
                                                                    state: {
                                                                        grupoTitulo: row.titulo.grupo,
                                                                    }
                                                                }}>
                                                                {textoReferencia}
                                                            </Link>
                                                        </div>;

                                                        var descricao = <div><strong>{row.descricao}</strong></div>;
                                                        return <div>
                                                            {referencia}
                                                            {descricao}
                                                        </div>;
                                                    },
                                                },
                                                {
                                                    name: 'Cliente',
                                                    selector: row => row.participante?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.participante ? row.participante.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Evento',
                                                    selector: row => row.titulo?.venda?.evento?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.titulo?.venda[0]?.evento ? row.titulo.venda[0].evento.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Competência',
                                                    selector: row => row.competencia ?? "",
                                                    sortable: true,
                                                    width: "120px",
                                                    cell: (row) => {
                                                        return row.competencia ? " " + moment(row.competencia).format("MM/YYYY") : "";
                                                    },
                                                },
                                                {
                                                    name: 'Vencimento',
                                                    selector: row => row.vencimento ?? "",
                                                    sortable: true,
                                                    width: "120px",
                                                    cell: (row) => {
                                                        return row.vencimento ? " " + moment(row.vencimento).format("DD/MM/YYYY") : "";
                                                    },
                                                },
                                                {
                                                    name: 'Pagamento',
                                                    selector: row => row.pagamento ?? "",
                                                    sortable: true,
                                                    width: "110px",
                                                    cell: (row) => {
                                                        return row.pagamento ? " " + moment(row.pagamento).format("DD/MM/YYYY") : "";
                                                    },
                                                },
                                                {
                                                    name: 'Valor',
                                                    selector: row => row.valor ?? "",
                                                    sortable: true,
                                                    right: true,
                                                    width: "120px",
                                                    cell: (row) => {
                                                        var valorAbater = row.titulosabatimento.reduce((total, atual) => total + parseFloat(atual.valorTotal), 0);
                                                        var valorFinal = row.valor - valorAbater;
                                                        if (valorAbater > 0) {
                                                            return <div>
                                                                <Link
                                                                    title="Visualizar despesa relacionada"
                                                                    to={{
                                                                        pathname: "/financeiroParcelaPagar",
                                                                        state: {
                                                                            parcelaabater: row.id,
                                                                        }
                                                                    }}>
                                                                    <div><del title={"Abatimento de " + moeda(valorAbater)}>{moeda(row.valor)}</del></div>
                                                                    <div className="d-block">{moeda(valorFinal)}</div>
                                                                </Link>

                                                            </div>;
                                                        } else {
                                                            return moeda(row.valor);
                                                        }
                                                    },
                                                },
                                            ]}
                                            data={parcelas}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
